import { render, staticRenderFns } from "./LanguageCreate.vue?vue&type=template&id=3a65a96a&scoped=true"
import script from "./LanguageCreate.vue?vue&type=script&lang=js"
export * from "./LanguageCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65a96a",
  null
  
)

export default component.exports